import SubFilters from './SubFilters';

export default SubFilters;



// WEBPACK FOOTER //
// ./src/components/FlatsList/SubFilters/index.js